import { render, staticRenderFns } from "./goodsConnectBox.vue?vue&type=template&id=56bd2ad2&scoped=true"
import script from "./goodsConnectBox.vue?vue&type=script&lang=js"
export * from "./goodsConnectBox.vue?vue&type=script&lang=js"
import style0 from "./goodsConnectBox.vue?vue&type=style&index=0&id=56bd2ad2&prod&scoped=true&lang=css"
import style1 from "./goodsConnectBox.vue?vue&type=style&index=1&id=56bd2ad2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bd2ad2",
  null
  
)

export default component.exports